"use client";

import React, { useContext, useEffect, useRef, useState } from "react";
import Scrollbars from "react-custom-scrollbars";
import $ from "jquery";
import Icons from "./Icons/index";

import { Context } from "./contexts/AppContext";
import { deleteData, getData, postData } from "../lib/utils";

import Header from "./Headers/Header";
import GalleryManager from "./Gallery/GalleryManager";
import { FaFolder, FaEllipsisV } from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faPencil, faSortAlphaDown, faSortAlphaUp, faFilter } from "@fortawesome/free-solid-svg-icons";

const SideNav = () => {
  const [selectedFolder, setSelectedFolder] = useState(false);
  const { value } = useContext(Context);
  const [appState, setAppState] = value;
  const [modalOpen, setModalOpen] = useState(appState.modalData);
  const mainDiv = useRef();

  const [sortOrder, setSortOrder] = useState(null); // null = no sort


  useEffect(() => {
    setModalOpen(appState.modalData);
  }, [appState.modalData]);

  useEffect(() => {
    const adjustHeight = () => {
      $("#mainDiv").css({ height: window.innerHeight - $("#header").height() + "px" });
    };
    setTimeout(adjustHeight, 1000);
    adjustHeight();
  }, [appState.allFolderData]);

useEffect(() => {
  (async () => {
    const _data = await getData("folder/folders");
    const data = _data.folders;
   localStorage.setItem("tPhotoCount", _data.totalPhotos || 0)
 
    if (data.length > 0) {
      // 🔍 find folder using _id
      data.reverse();
      const currentFolder =
        data.find((f) => f._id === appState?.currentFolderId) || data[0];

      setAppState((prevState) => ({
        ...prevState,
        currentFolderData: currentFolder,
        currentFolderName: currentFolder?.name,
        currentFolderId: currentFolder?._id, // ✅ ID store
        allFolderData: data,
        modalData: { ...prevState.modalData, folderUpdate: false },
      }));

      setSelectedFolder(true);
    } else {
      localStorage.removeItem("appState");
    }
  })();
}, [modalOpen?.folderUpdate]);


  const BASE_ITEMS = [{ id: "newfolder", name: "AddFolder", txt: "Create Folder" }];

  return (
    <div className="relative min-h-screen">
      <Header />
      <div className="md:flex min-h-screen pb-8 border-2" id="mainDiv" ref={mainDiv}>
        <Sidebar BASE_ITEMS={BASE_ITEMS} setAppState={setAppState} appState={appState} />
        <ContentArea selectedFolder={selectedFolder} />
      </div>
    </div>
  );
};

// ---------------- Sidebar ----------------
// ---------------- Sidebar ----------------
const Sidebar = ({ BASE_ITEMS, setAppState, appState }) => {
  const [menuOpenState, setMenuOpenState] = useState({});
  const [search, setSearch] = useState("");
  const [sortOrder, setSortOrder] = useState(null); // null = no sort
  const menuRefs = useRef({});

  // Close menu on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      let clickedInside = false;
      Object.values(menuRefs.current).forEach((ref) => {
        if (ref && ref.contains(event.target)) clickedInside = true;
      });
      if (!clickedInside) setMenuOpenState({});
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleMenu = (folderId) => {
    setMenuOpenState((prev) => ({
      [folderId]: !prev[folderId],
    }));
  };

  const folderDeleteHandler = async (folderId) => {
    if (!window.confirm("Are you sure you want to delete this Folder?")) return;
    try {
      await postData("products/delete-file", { folderName: folderId });
      await deleteData(`folder/folders/${folderId}`);
      alert("Folder Deleted successfully");
      window.location.reload();
    } catch (error) {
      console.error("Error deleting folder:", error);
    }
  };

  const renameBtnHandler = () => {
    setAppState((prev) => ({
      ...prev,
      modalData: { ...prev.modalData, type: "RenameModal", isOpen: true },
    }));
  };

  // 🔍 SEARCH (always active)
  const filtered = appState.allFolderData.filter((folder) =>
    folder.name.toLowerCase().includes(search.toLowerCase())
  );

  // 🔀 SORT (only when user clicks)
  const displayedFolders = sortOrder
    ? [...filtered].sort((a, b) =>
        sortOrder === "asc"
          ? a.name.localeCompare(b.name)
          : b.name.localeCompare(a.name)
      )
    : filtered;

  return (
    <div className="text-[0.9rem] font-semibold sidebar bg-[#eeeeee] w-[280px] space-y-6 py-7">
      {/* 🔍 Search + Sort */}
      <div className="px-3">
        <input
          type="text"
          className="w-full px-3 py-2 mb-3 border rounded"
          placeholder="Search folders..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <button
          onClick={() =>
            setSortOrder((prev) =>
              prev === "asc" ? "desc" : prev === "desc" ? null : "asc"
            )
          }
          className="px-3 py-1 bg-gray-800 text-white rounded w-full flex items-center justify-center gap-2 mb-4"
        >
          {sortOrder === "asc" && (
            <>
              <FontAwesomeIcon icon={faSortAlphaDown} /> A–Z
            </>
          )}
          {sortOrder === "desc" && (
            <>
              <FontAwesomeIcon icon={faSortAlphaUp} /> Z–A
            </>
          )}
          {sortOrder === null  && (
            <>
              <FontAwesomeIcon icon={faFilter} /> A–Z / Z-A
            </>
          )}
        </button>
      </div>

      {/* ➕ New Folder Button */}
      <nav className="px-3">
        {BASE_ITEMS.map((item) => (
          <PanelListItem key={item.name} {...item} />
        ))}
      </nav>

      {/* 📂 Folder List */}
      <Scrollbars autoHeight autoHeightMin={300} autoHeightMax={"calc(100vh - 280px)"}>
        <div className="p-2 space-y-2">
          {displayedFolders.map((folder) => (
            <div
              key={folder._id}
              ref={(el) => (menuRefs.current[folder._id] = el)}
              className={`flex items-center justify-between p-3 border rounded-lg cursor-pointer hover:bg-gray-200 ${
                appState.currentFolderId === folder._id ? "bg-gray-300" : ""
              }`}
              onClick={() =>
              {

                {console.log("FOLDER ID ",folder._id)}
                
                setAppState((prev) => ({
                  ...prev,
                  currentFolderData: folder,
                  currentFolderName: folder.name,
                  currentFolderId: folder._id, // ✅ FIXED
                }))
              } }
            >
              <div className="flex items-center gap-3">
                <FaFolder className="text-yellow-500" size={20} />
                <span>{folder.name}</span>
              </div>

              <div className="relative">
                <button
                  onClick={(e) => {

                    setAppState((prev) => ({
                  ...prev,
                  currentFolderData: folder,
                  currentFolderName: folder.name,
                  currentFolderId: folder._id, // ✅ FIXED
                }))
                    e.stopPropagation();
                    toggleMenu(folder._id);
                  }}
                  className="p-2 text-gray-600 hover:text-gray-800"
                >
                  <FaEllipsisV size={16} />
                </button>

                {menuOpenState[folder._id] && (
                  <div className="absolute right-0 mt-2 w-40 bg-white border rounded-lg shadow-lg z-10">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        renameBtnHandler();
                      }}
                      className="flex items-center gap-2 w-full px-4 py-2 text-left hover:bg-gray-100"
                    >
                      <FontAwesomeIcon icon={faPencil} />
                      Rename
                    </button>

                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        folderDeleteHandler(folder._id);
                      }}
                      className="flex items-center gap-2 w-full px-4 py-2 text-left hover:bg-gray-100"
                    >
                      <FontAwesomeIcon icon={faTrash} />
                      Delete
                    </button>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </Scrollbars>
    </div>
  );
};

// ---------------- Content Area ----------------
const ContentArea = ({ selectedFolder }) => (
  <div
    id="sideDetailedTray"
    className="relative w-full border-2 border-[#a5bce9] bg-white rounded-lg mt-2 mb-8 mx-2"
  >
    {selectedFolder && <GalleryManager />}
  </div>
);

// ---------------- New Folder Button ----------------
const PanelListItem = ({ name, txt, activePanel }) => {
  const { value } = useContext(Context);
  const [appState, setAppState] = value;
  const Icon = Icons[name];

  const openFolderModal = () => {
    setAppState((prev) => ({
      ...prev,
      modalData: { ...prev.modalData, type: "NewFolderModal", isOpen: true },
    }));
  };

  return (
    <button
      type="button"
      onClick={openFolderModal}
      className={`w-[150px] flex items-center justify-center font-medium text-sm border rounded-md p-2 gap-2 transition-all duration-500 ${
        name === activePanel ? "bg-white" : "bg-[#eeeeee]"
      }`}
    >
      <Icon />
      {txt}
    </button>
  );
};

export default SideNav;
